module.exports = {"450123100":"城厢镇","450123101":"南圩镇","450123102":"雁江镇","450123103":"那桐镇","450123104":"乔建镇","450123105":"丁当镇","450123201":"古潭乡","450123203":"都结乡","450123204":"布泉乡","450123205":"屏山乡","450123450":"隆安华侨管理区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450123.json
// module id = 2202
// module chunks = 0